import moment from 'moment';

export const formatDateStr = (ts, format = 'hh:mm:ss MM-DD-YYYY') => {
  return moment.unix(ts).format(format);
};

export const calDuration = (startTime, endTime) => {
  const start = moment.unix(startTime);
  const end = moment.unix(endTime);
  const diff = moment.duration(end.diff(start));
  return moment.utc(diff.asMilliseconds()).format('HH:mm:ss');
};

export const toHoursAndMinutes = (totalSeconds) => {
  if (totalSeconds > 0) {
    const totalMinutes = Math.floor(totalSeconds / 60);

    const seconds = totalSeconds % 60;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return { h: hours, m: minutes, s: seconds };
  } else {
    return { h: 0, m: 0, s: 0 }
  }
}
export const getDiffTimeFromNow = (startTime) => {
  return new Date().getTime() - startTime;
};
